import {Child} from '@/hosted_fields/common/enums';
import ComponentFactory from '@/hosted_fields/component/main';
import actionHolder from '@/hosted_fields/common/holder';
import {ActionInnerMessage, ResponseInnerMessage} from '@/hosted_fields/common/types';

export default (client) => {
  actionHolder.registerAction(Child.Actions.LoadComponent, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.create(client, message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.FetchData, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.fetchData();
    },
  });
  actionHolder.registerAction(Child.Actions.selectTestCard, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.selectTestCard(message);
    },
  });
  actionHolder.registerAction(Child.Actions.sendConfigData, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.configData(message.data);
    },
  });
  actionHolder.registerAction(Child.Actions.ReceiveStatusBroadcast, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.receiveStatus(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.Focus, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.focus();
    },
  });

  actionHolder.registerAction(Child.Actions.Blur, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.blur();
    },
  });

  actionHolder.registerAction(Child.Actions.Clear, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.clear();
    },
  });

  actionHolder.registerAction(Child.Actions.Destroy, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.destroy();
    },
  });

  actionHolder.registerAction(Child.Actions.Validate, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.validate();
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateFonts, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateFonts(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateStyles, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateStyles(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdatePlaceholder, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updatePlaceholder(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateAriaLabel, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateAriaLabel(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateIcon, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateIcon(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateLocale, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateLocale(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.UpdateIDealBankList, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.updateIDealBankList(message.data);
    },
  });

  actionHolder.registerAction(Child.Actions.IDealBankSelected, {
    handle(message: ActionInnerMessage) {
      return ComponentFactory.iDealBankSelected(message.data);
    },
  });
};
